<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import IOSNotchDetector from './IOSNotchDetector.js'

export default {
  created() {
    // 使用示例
    console.log('是否刘海屏:', IOSNotchDetector.isNotchScreen());
    console.log('是否大尺寸刘海屏:', IOSNotchDetector.isLargeNotchScreen());
    console.log('屏幕信息:', IOSNotchDetector.getScreenInfo());
    if(IOSNotchDetector.isNotchScreen() || IOSNotchDetector.isLargeNotchScreen()){
      document.documentElement.style.setProperty("--app-status-bar-height","44px");
      document.documentElement.style.setProperty("--app-bottom-tabbar-height","34px");
    }else{
      document.documentElement.style.setProperty("--app-status-bar-height","22px");
      document.documentElement.style.setProperty("--app-status-bar-height","0px");
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Roboto, Roboto';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  padding-top: calc(var(--app-status-bar-height) + 12px);
  padding-bottom: var(--app-bottom-tabbar-height);
  // height: 100vh;
  // overflow: hidden;
  // font-size: 1rem;
}
div, p, span, h1, h2, h3, h4, h5, button{
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
body {
  margin: 0px;
  padding:0px;
}
:root {
  /* app状态栏高度(为了兼容ios app全屏模式webview侵入状态栏，在app.vue里面会修改此变量的值) */
  --app-status-bar-height:1px;
  --app-bottom-tabbar-height:1px;
}
</style>
